import { store } from '@/stores';

export const parseJwt = (token?: string | null): PartialCredentials => {
  if (!token) {
    return {};
  }
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      Buffer.from(base64, 'base64')
        .toString()
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return {};
  }
};

export const getLoginStatus = (): boolean => {
  const access_token = store.getState().auth.user?.token;

  const decodeCredentials = parseJwt(access_token);
  const now = new Date().getTime() / 1000;

  return !!access_token && !!decodeCredentials?.role && !!decodeCredentials?.exp && now < decodeCredentials?.exp;
};
